import WarehousesSection from "./WarehousesSection.jsx";
import UserSettingsSection from "./UserSettingsSection.jsx";
import CurrencyPicker from "./CurrencySection.jsx";
import LeftMenuNavSection from "components/LeftMenuNavSection";
import { useAuth } from "database/useAuth";
import { canAccessStockIssues } from "pages/stockIssuesPage/allowlist";
import clsx from "clsx";

const LeftMenu = ({ selectedWarehouse, onSelectedWarehouse, onMenuClose }) => {
  const { user } = useAuth();

  // Calculate the number of navigation sections
  const hasProjectsNav = user?.userAccess?.includes("projects");
  // Stock Issues is a limited pilot — allowlist-gated by email. See
  // pages/stockIssuesPage/allowlist.js (mirrored server-side).
  const hasStockIssuesNav = canAccessStockIssues(user);
  const hasAdminNav = user?.isSuperAdmin;
  const navSectionCount =
    (hasProjectsNav ? 1 : 0) +
    (hasStockIssuesNav ? 1 : 0) +
    (hasAdminNav ? 1 : 0);

  // Determine grid rows based on navigation sections
  let gridRows;
  if (navSectionCount === 0) {
    gridRows = "grid-rows-[1fr] pt-5";
  } else if (navSectionCount === 1) {
    gridRows = "grid-rows-[auto_1fr]";
  } else if (navSectionCount === 2) {
    gridRows = "grid-rows-[auto_auto_1fr]";
  } else {
    gridRows = "grid-rows-[auto_auto_auto_1fr]";
  }

  return (
    <div
      className={clsx(
        "grid h-full overflow-y-hidden",
        gridRows,
      )}
    >
      {hasProjectsNav && (
        <LeftMenuNavSection
          location={{
            name: "Projects",
            url: "/private/projects",
            direction: "right",
          }}
        />
      )}
      {hasStockIssuesNav && (
        <LeftMenuNavSection
          location={{
            name: "Stock Issues",
            url: "/private/stock-issues",
            direction: "right",
          }}
        />
      )}
      {hasAdminNav && (
        <LeftMenuNavSection
          location={{
            name: "Admin",
            url: "/private/admin",
            direction: "right",
          }}
        />
      )}
      <div className="flex flex-col justify-between overflow-y-auto pt-5">
        <div className="flex flex-col gap-5">
          <div className="px-2">
            <WarehousesSection
              selectedWarehouse={selectedWarehouse}
              onSelectedWarehouse={onSelectedWarehouse}
            />
          </div>
          <div className="px-2">
            <CurrencyPicker onCloseModal={onMenuClose} />
          </div>
        </div>
        <div className="px-2">
          <UserSettingsSection />
        </div>
      </div>
    </div>
  );
};

export default LeftMenu;
